import React, { useState } from 'react';
import {
  createActionSettingsSchema,
  getFieldInfoByName,
  validateResponseDataSessionKey,
} from './Util';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel.js';
import BrowserStorageOptions from '../BrowserStorageOptions.js';
import CustomLoader from '../../../common/CustomLoader.js';
import CustomSelect from '../../../../common/formElements/CustomSelect.js';

export const CloneCollectionItemForm = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  actions,
  hideModal,
  showLoaderForAction,
  version,
  events,
}) => {
  const [showBSLOption, setShowBSLOption] = useState(false);

  const collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const fieldOptions = (collectionName) => {
    let options = [{ value: '', label: 'Choose Display Field' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      const selectedCollection = collections.find((coll) => coll.collectionName === collectionName);
      if (selectedCollection && selectedCollection.fields) {
        options = options.concat(
          selectedCollection.fields.map((field) => {
            return { value: field.fieldName, label: field.fieldTitle.en };
          }),
        );
      }
    }
    return options;
  };

  const handleSubmit = (values) => {
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
        setSubmitting(false);
        resetForm();
      }}
    >
      {({ isSubmitting, values, setFieldValue, setFieldTouched, errors, isValidating }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Collection"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('collection')}
                  >
                    <CustomSelect
                      name={'collection'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={collectionOptions()}
                      value={values['collection']}
                    />
                    <ErrorMessage name={'collection'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Display Field"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('displayField')}
                  >
                    <CustomSelect
                      name={'displayField'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={fieldOptions(values['collection'])}
                      value={values['displayField']}
                    />
                    <ErrorMessage name={'displayField'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Exclude Fields"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('excludeFields')}
                  >
                    <CustomSelect
                      name={'excludeFields'}
                      isMulti={true}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={fieldOptions(values['collection'])}
                      value={values['excludeFields']}
                    />
                    <ErrorMessage name={'excludeFields'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Success Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('successMessage')}
                  >
                    <Field
                      name="successMessage"
                      type="text"
                      placeholder="(Optional) Enter custom success message."
                      className="form-control form-control-sm"
                    />
                  </FormFieldWithLabel>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Error Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('errorMessage')}
                  >
                    <Field
                      name="errorMessage"
                      type="text"
                      placeholder="(Optional) Enter custom error message."
                      className="form-control form-control-sm"
                    />
                  </FormFieldWithLabel>
                </div>
              </div>
              <div className="form-group">
                <button
                  onClick={(e) => setShowBSLOption(!showBSLOption)}
                  className="btn btn-icon-only btn-outline-info ml-5 p-1"
                  title="Show Browser Storage Options"
                  type="button"
                >
                  <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                </button>
              </div>
              {showBSLOption && (
                <BrowserStorageOptions
                  values={values}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  validateResponseDataSessionKey={validateResponseDataSessionKey}
                  saveFormDataInBrowserStorage={false}
                />
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i> Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className={`btn btn-sm btn-theme-submit`}>
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
